module.exports = __webpack_public_path__ + "static/atsi-6b5d06e910be20d593f96c4869d7cfd5.png";